<template>
<div class="mt-3">


<spinner v-bind:spinner='spinner'></spinner>


   

   <div v-if="type== 'A' "> 

    <div class="row"> 
    <div class="col"> 

    <bertini v-if="company.Id == 49" v-bind:productId="item.productId"></bertini>  

    <ul v-if="company.Id != 49" id="example-2" class="list-group">
    <li  v-for="(item, index) in items" :key='index' class="list-group-item d-flex justify-content-between align-items-center">
      <div v-if="item.api == 'Y'">  
              <!--<span v-if="item.productId"  class="fas fa-certificate ml-3 mr-3" role="status" aria-hidden="true"></span>-->
              <button class="btn btn-info btn-sm " type="button">
                {{item.MarketPlace}}
              </button>
              <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
              </button> 
              <div class="dropdown-menu">
                <a v-bind:class="{ disabled : item.spinner}" class="dropdown-item" href="#" @click="syncApi(index)">
                   
                   <i style="color:blue" class='fas fa-cloud-upload-alt mr-2'></i> 
                  Sincronizza </a>
              </div>
             
           
            
               <span v-if="item.spinner"  class="spinner-border spinner-border-sm ml-3 mr-3" role="status" aria-hidden="true"></span>
               <span v-if="item.spinner"  class="" role="status" aria-hidden="true">
                 Sincronizzazione in corso ...
               </span>
              <!-- <span v-if="item.check"  class="far fa-check-circle ml-3 " role="status" aria-hidden="true"></span>  -->
              
              <div v-if="item.err"  class="alert mt-2 ml-2" v-bind:class="item.alert"   role="alert">
                   <i class='fas fa-bullhorn mr-3'></i> 
                  <strong> {{item.err}} </strong>
              
              </div>

              
      </div>

          <div v-else >
           
            <div v-if="company.Id != 49">   

            <button v-if="item.component" @click="setComponent(item.component)" type="button" v-bind:class = "[item.class ? 'btn btn-outline-success  mb-2 rounded' : 'btn btn-outline-danger  mb-2 rounded' ]"  >
               <i :class="item.component ? 'fas fa-edit mr-3':''"></i> 
               <strong>{{item.MarketPlace}}</strong>  
            </button> 

            <label v-else class="control-label" :for="'mp_' + index">
                <strong>{{item.MarketPlace}}</strong>
            </label>
            
            <span class="custom-control custom-switch">
                        
              <input type="checkbox" class="custom-control-input" @click="updateProduct(item,!item.productId)" :id="'mp_' + index" v-model="item.productId" >
              <label class="custom-control-label" :for="'mp_' + index">
                <strong>{{item.productId  ? 'associato':'non associato'}}
                <!-- <span v-if="item.check"  class="far fa-check-circle ml-3 " role="status" aria-hidden="true"></span>  -->


                </strong>
              </label>
              </span>
                       
          </div> 
          
          
        </div>
      

    </li>

  </ul>

      <button v-if="items.length>1" type="button" @click="updateAll()"  class="btn btn-warning mt-2 ml-2 ">
        <i class="fas fa-edit mr-2" aria-hidden="true"></i>
        ASSOCIA PER TUTTI I MARKET
      </button> 

    </div>
    

  
  
  <div class="col">  
    <div v-if="items.length>0">
      <prod-description  :key="refresh" @update="setDescription" v-bind:_description ="description"></prod-description>
    </div>
    <button :disabled="items.length==0" type="button" @click="updateProductLongDescription()"  class="btn btn-primary float-left ml-2">
       <i class="fas fa-edit mr-2" aria-hidden="true"></i>
       MODIFICA
      <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
  </button> 
      
  </div>
  
  
    </div>
    
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  
  </div>
  
  <div v-else-if="type=='giglio'">
    <giglio class="ml-4 mb-2 mr-4" v-bind:productId="item.productId" @close="type='A',getData()"></giglio>
  </div>  

  <div v-else-if="type=='italist'">
    <italist class="ml-4 mb-2 mr-4" v-bind:productId="item.productId" @close="type='A',getData()"></italist>
  </div>  

  <div v-else-if="type=='miinto'">
    <miinto class="ml-4 mb-2 mr-4" v-bind:productId="item.productId" @close="type='A',getData()"></miinto>
  </div>  


  

  </div>
  
  




</template>

<script>

import axios              from 'axios'
import api                from "@/api"
import alertBox           from '@/components/common/AlertBox.vue';

import spinner            from '@/components/common/Spinner.vue';
import prodDescription    from '@/components/common/ProductDescription.vue';
import giglio             from '@/components/mp/Giglio.vue';
import italist            from '@/components/mp/Italist.vue';
import miinto             from '@/components/mp/Miinto.vue';
import bertini            from '@/components/mp/Bertini.vue';
import { mapGetters }     from 'vuex';



export default {
   props : ['item'],
   components: { alertBox, spinner, prodDescription, giglio, italist, miinto, bertini },  
  
  data () {
    return {

      
      items           : [],      
      msg             : {
        title      : ''
      },
      alert           : false,
      spinner         : false,
      bt_spinner      : false,
      description     : '',
      refresh         : 0,
     
      type            : 'A',
      
     
     
     
      

    }
  },
  computed: 
  {
   
   ...mapGetters(['company']),
  
   
  },
   

  created()
  {
    
    this.getData()
   
  },

  methods: 
  {

    updateAll()
    {
      this.items.forEach(item=>{
        let data = {'productId':this.item.productId,'mpId':item.mpId,'insert':true}
        this.updateProductMP(data,item)
        item.productId = this.item.productId
      })
    },
    updateProduct(item,insertItem)
    {

      const data = {'productId':this.item.productId,'mpId':item.mpId,'insert':insertItem}
      this.updateProductMP(data,item)    

    },
    sendMsg()
    {

      let productInAllMP = true

      this.items.forEach(item=>
      {
        if(item.productId == false)
        {
          productInAllMP = false
        }
                
      })

      const data = {'productId': this.item.productId,'productInMP' : productInAllMP}
      this.$emit('sendData',data)

    },


    async getBertiniToken()
    {
     

      return new Promise( async (resolve, reject)  =>  {
      await api.bertini.getToken().then(res => {
        
          if(res.status==200)
            {
              
              resolve(res.data.token)
              
            }
             
           else
            {
              const token = ''
              resolve(token)
              
            } 
      

          }).catch(err => {
            const token = ''
              resolve(token)
              
          }).finally(() => {
                //this.spinner = false
        });
      })

    },

   
    async syncBertini()
    {
     
      this.spinner   = true
      let token = ''
      token = await this.getBertiniToken()
      
    
      if(token)
      {
        this.token_msg = ''
        const today = new Date();
      
        this.token_msg = token + ' ' + today.toLocaleDateString()
        /*
      function wait(ms)
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }
      */

        const data     = await this.getBertiniProductData(this.item.productId)
      
        const product  = {product: data[0][0] }
        const variants = this.getBertiniVariants(data[1])
        const stock    = this.getBertiniStock(data[1])
        const seo      = this.getBertiniSeo(product)
        
        //this.spinner   = true
        //await wait(0) 
        //alert(this.spinner)
        this.bertini = false
        const response1 = await api.bertini.postProduct(product,token)  
        
        this.response1 = response1
        if(this.response1.status == 200)
        {
          this.response1.statusText =  'Sincronizzazione Prodotto effettuata con successo.'
        }
        
        console.log('Res1',response1.status)

        const response2 = await api.bertini.postVariants(variants,token)  
        this.response2 = response2

        if(this.response2.status == 200)
        {
          this.response2.statusText =  'Sincronizzazione Varianti prodotto effettuata con successo.'
        }  

        console.log('Res2',response2)

        const response3 = await api.bertini.postStock(stock,token)  
        this.response3 = response3
        if(this.response3.status == 200)
        {
          this.response3.statusText =  'Sincronizzazione Stock  effettuata con successo.'
        }




        console.log('Res3',response3)

        const response4 = await api.bertini.postSeo(seo,token)  
        this.response4 = response4
        console.log('Res4',response4)
        
        this.spinner = false
        this.bertini = true


        
      }

      
    },

    getBertiniVariants(items)
    {
      let data = {'variants':[]}
      items.forEach(item => {
        item.additional_informations = JSON.stringify({'CODICE_FORNITORE': item.codice_fornitore,'EAN':item.EAN})
        item.product_code = item.product_code.toString()
        data.variants.push(item)
      })
      return data
    },
    getBertiniStock(items)
    {
      let data = {'variants':[]}
      items.forEach(item => {
        data.variants.push({'product_code':item.product_code,'variant_code':item.variant_code,'warehouse_id':'1','stock':item.stock.toString()})
      })

      return data
    },
    getBertiniSeo(item)
    {
      
      let data = {'product':{'product_code':item.product.product_code,'variant_code':'','title':item.product.description,"id_store_view":"1"}}
      

      return data
    },
    getBertiniProductData(productId)
    {
       const sp       = {'sp':'spSyncBertiniMax'}
       const data     = {'productId' : productId}
       
       this.spinner = true

       const json = Object.assign(data, sp);
      
       return new Promise( async (resolve, reject)  =>  {

        await api.post(json).then(res => {
                  
          if(res.status==200)
            {
              
              

              if(res.data.recordsets[0].length > 0)
              {
                
                resolve(res.data.recordsets)
              }
              else
              {
                resolve([])
              }
              
            }
           else if(res.status==500)
           {
              resolve([])
              /*
              this.msg.title = 'ATTENZIONE '                              
              this.msg.body = res.data              
              this.msg.type = 1               
              resolve(false)
              */
                                    
           } 
           else
            {
              resolve([])
              /*
              this.msg.title = 'ATTENZIONE '  
              this.msg.body = res 
              this.msg.type = 1                          
              resolve(false)
              */
            } 
          

          }).catch(err => {
              
              resolve([])
              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message 
              this.msg.type = 1                
              */
          }).finally(() => {
              
              //this.spinner = false
        });
        
        
        
       })      
    },
   
    async syncApi(index)
    {
      
      if(this.company.Id == 49)
      {
        this.syncBertini()
        return
      }

      let obj      = this.items[index]
      obj.err      = ''      
      obj.alert    = 'alert-success'
     
      obj.spinner  = true

      let api_name = obj.api_name

      this.$set(this.items,index,obj)
      
      let body = {

        'companyId' : this.company.Id,
        'productId' : this.item.productId,
       // 'mpId'      : item.mpId

      }

      let url   = process.env.VUE_APP_ROOT_API + 'sync/' + api_name 
                          
              
              axios({
              url    : url,
              method : "post",
              data   : body
              }).then(res => {
                               
                obj.err       = res.data.msg
                obj.alert     = res.data.alert               
                obj.productId = true
                
                this.$set(this.items,index,obj)
                
                this.updateProduct(obj,true)

                this.sendMsg()
                
                

              }).catch(err => {

                
                if(err.response)
                {
                  
                  obj.err       = 'Errore ' +  err.response.status + ' ' + err.response.statusText 
                }
                else
                {
                  obj.err       = err
                }
                obj.alert = 'alert-warning'
                this.$set(this.items,index,obj)
                
                

              }).finally(() => {

                obj.spinner = false
                this.$set(this.items,index,obj)
                 
                
              })

    },
    setComponent(component)
    {
      if(component)
      {
        this.type = component
        
      }
    },
    setDescription(data)
    {
      this.description = data
    },

  

    async getData()
    {
    

    this.msg.title = ''
    this.description = ''
    
    this.spinner  = true
        
    var data      = {'productId' : this.item.productId,'companyId':this.company.Id}
    var sp        = {'sp' : 'spProductMarketPlace'}
    var json      = Object.assign(data, sp);

    await api.post(json).then(res => {
          
      
          if(res.status==200)
            {
              
              let items = res.data.recordsets[0]
              //this.items = res.data.recordsets[0]
              
                             
              items.forEach(async item=>
              {
                item.class   = false
                item.check   = false              
                item.spinner = false
                item.err     = ''
                item.alert   = 'alert-success'
                
                // Classificazione 
                if(item.component )
                {
                  item.class = await this.checkProductClass(item.component,data.productId)
          
                }
                   
              })  
              
              
            this.items = items
            if(items && res.data.recordsets[1].length>0)
            {
              this.description = res.data.recordsets[1][0].description     
              this.refresh++
            }  

            }
            else if(res.status==500)
            {
                               
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data              
                this.msg.type = 1                            
                    
           } 
           else
            {
                            
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type = 1              
            } 
      

          }).catch(err => {
                          
                this.msg.title = 'ATTENZIONE '
                this.msg.body = err.message
                this.msg.type = 1              
              
          }).finally(() => {
                this.spinner = false
        });

        
    
    },  
   
    async checkProductClass(mp,productId)
    {

       
       let sp       = {'sp':'spProductClassChecking' + mp}
       let data     = {'productId':productId}
       this.spinner = true
       var json = Object.assign(data, sp);
      
       return new Promise( async (resolve, reject)  =>  {

        await api.post(json).then(res => {
                  
          if(res.status==200)
            {
              
              

              if(res.data.recordsets[0].length > 0)
              {
                
                resolve(true)
              }
              else
              {
                resolve(false)
              }
              
            }
           else if(res.status==500)
           {
              this.msg.title = 'ATTENZIONE '                              
              this.msg.body = res.data              
              this.msg.type = 1               
              resolve(false)
                                    
           } 
           else
            {
              this.msg.title = 'ATTENZIONE '  
              this.msg.body = res 
              this.msg.type = 1                          
              resolve(false)
            } 
          

          }).catch(err => {
              
              resolve(false)
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message 
              this.msg.type = 1                
              
          }).finally(() => {
              
              this.spinner = false
        });
        
        
        
       })      
    },
   
    
    async updateProductMP(data,item)
    {

       item.check   = false
       var sp       = {'sp':'spUpdateProductMarketPlace'}
       this.spinner = true
       var json = Object.assign(data, sp);
                
        await api.post(json).then(res => {
                  
          if(res.status==200)
            {
              
              
              item.check = true
              this.sendMsg()              
              
            }
           else if(res.status==500)
           {
              this.msg.title = 'ATTENZIONE '                              
              this.msg.body = res.data              
              this.msg.type = 1               
                                    
           } 
           else
            {
              this.msg.title = 'ATTENZIONE '  
              this.msg.body = res 
              this.msg.type = 1                          
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message 
              this.msg.type = 1                
              
          }).finally(() => {
          this.spinner = false
        });
        
        
        
          
    },
    

    async updateProductLongDescription()
    {

       let data                = {}
       data.productId   = this.item.productId
       data.description = this.description
        
       var sp       = {'sp':'spUpdateProductLongDescription'}
       this.spinner = true
       var json = Object.assign(data, sp);
                
        await api.post(json).then(res => {
          
        
        
          if(res.status==200)
            {
                
              

              //this.sendMsg()
              this.msg.title = 'MODIFICA EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              
            }
           else if(res.status==500)
           {
              this.msg.title = 'ATTENZIONE '                              
              this.msg.body = res.data              
              this.msg.type = 1               
                
                    
           } 
           else
            {
              this.msg.title = 'ATTENZIONE '  
              this.msg.body = res 
              this.msg.type = 1                          
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message 
              this.msg.type = 1                
              
          }).finally(() => {
          this.spinner = false
        });
        
        
        
          
    },
    
      
  }
  
}
</script>

<style scoped>
    
    .err
    {
      color  :  darkred;
    }
    .custom-control-label
    {
      cursor : pointer; 


    }
    h4 {
     
      font-size: 20px;
    }
    .bold
    {
        font-weight  : bold;
    }
    
    label{
      color  :  darkblue
    }
    p {
     
      font-size    : 25px;
    }
    span {
     
      font-size    : 15px;
      color  :  darkgreen;

    }
    .btn-link {
      color: firebrick !important;
    }
</style>